import React, { useEffect } from "react";
import { Redirect } from "expo-router";

import { useSession } from "@/context/auth/useSession";

export default function Page(): React.JSX.Element {
  const { signOut } = useSession();

  useEffect(() => {
    signOut();
  }, []);

  return <Redirect href="/" />;
}
